var Vendd = (function (Vendd) {
	'use strict';

	Vendd.WarehouseSelector = (function (WarehouseSelector) {

		WarehouseSelector.Messages = (function (Messages) {

			Messages.GetModel = function () {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetModel', {});
			};
			Messages.GetModel.className = 'Vendd.WarehouseSelector.Messages.GetModel';

			Messages.GetModelSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetModelSuccess', response);
			};
			Messages.GetModelSuccess.className = 'Vendd.WarehouseSelector.Messages.GetModelSuccess';

			Messages.GetModelFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetModelFailed', response);
			};
			Messages.GetModelFailed.className = 'Vendd.WarehouseSelector.Messages.GetModelFailed';


			Messages.GetPopupModel = function () {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetPopupModel', {});
			};
			Messages.GetPopupModel.className = 'Vendd.WarehouseSelector.Messages.GetPopupModel';

			Messages.GetPopupModelSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetPopupModelSuccess', response);
			};
			Messages.GetPopupModelSuccess.className = 'Vendd.WarehouseSelector.Messages.GetPopupModelSuccess';

			Messages.GetPopupModelFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetPopupModelFailed', response);
			};
			Messages.GetPopupModelFailed.className = 'Vendd.WarehouseSelector.Messages.GetPopupModelFailed';


			Messages.OpenPopup = function () {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.OpenPopup', {});
			};
			Messages.OpenPopup.className = 'Vendd.WarehouseSelector.Messages.OpenPopup';


			Messages.ClosePopup = function () {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.ClosePopup', {});
			};
			Messages.ClosePopup.className = 'Vendd.WarehouseSelector.Messages.ClosePopup';


			Messages.StateChanged = function (state) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.StateChanged', {
					state: state
				});
			};
			Messages.StateChanged.className = 'Vendd.WarehouseSelector.Messages.StateChanged';


			Messages.GetGeoAreas = function (postCode) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetGeoAreas', {
					PostalCode: postCode
				});
			};
			Messages.GetGeoAreas.className = 'Vendd.WarehouseSelector.Messages.GetGeoAreas';

			Messages.GetGeoAreasSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetGeoAreasSuccess', response);
			};
			Messages.GetGeoAreasSuccess.className = 'Vendd.WarehouseSelector.Messages.GetGeoAreasSuccess';

			Messages.GetGeoAreasFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetGeoAreasFailed', response);
			};
			Messages.GetGeoAreasFailed.className = 'Vendd.WarehouseSelector.Messages.GetGeoAreasFailed';


			Messages.GetStoresByPostCode = function (postCode) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetStoresByPostCode', {
					PostalCode: postCode
				});
			};
			Messages.GetStoresByPostCode.className = 'Vendd.WarehouseSelector.Messages.GetStoresByPostCode';

			Messages.GetStoresByGeoArea = function (postCode, geoAreaId) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetStoresByGeoArea', {
					PostalCode: postCode,
					GeoAreaId: geoAreaId
				});
			};
			Messages.GetStoresByGeoArea.className = 'Vendd.WarehouseSelector.Messages.GetStoresByGeoArea';

			Messages.GetStoresByLocation = function (location) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetStoresByLocation', {
					Location: location
				});
			};
			Messages.GetStoresByLocation.className = 'Vendd.WarehouseSelector.Messages.GetStoresByLocation';

			Messages.GetStoresSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetStoresSuccess', response);
			};
			Messages.GetStoresSuccess.className = 'Vendd.WarehouseSelector.Messages.GetStoresSuccess';

			Messages.GetStoresFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.GetStoresFailed', response);
			};
			Messages.GetStoresFailed.className = 'Vendd.WarehouseSelector.Messages.GetStoresFailed';


			Messages.SetDeliveryShippingMethod = function () {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.SetDeliveryShippingMethod', {});
			};
			Messages.SetDeliveryShippingMethod.className = 'Vendd.WarehouseSelector.Messages.SetDeliveryShippingMethod';


			Messages.SetFromStoreShippingMethod = function (storeId) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.SetFromStoreShippingMethod', {
					PreferredStoreId: storeId
				});
			};
			Messages.SetFromStoreShippingMethod.className = 'Vendd.WarehouseSelector.Messages.SetFromStoreShippingMethod';

			Messages.SetShippingMethodSuccess = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess', response);
			};
			Messages.SetShippingMethodSuccess.className = 'Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess';

			Messages.SetShippingMethodFailed = function (response) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.WarehouseSelector.Messages.SetShippingMethodFailed', response);
			};
			Messages.SetShippingMethodFailed.className = 'Vendd.WarehouseSelector.Messages.SetShippingMethodFailed';

			return Messages;

		})(WarehouseSelector.Messages || {});

		return WarehouseSelector;

	})(Vendd.WarehouseSelector || {});

	return Vendd;

})(Vendd || {});